'use client';

import Image from 'next/image';
import Link from 'next/link';
import { TEST_IDS } from './constants/testIds';
import { PULSE_NAMES } from '@/constants/pulseNames';
import { GENAI_LOGO_URL } from '@/constants/brand';
import HeaderAuthSlot from '@/components/HeaderAuthSlot';
import SearchDropdown from '@/components/SearchDropdown';
import HeaderSearchLink from '@/components/HeaderSearchLink';
import useStyles from './styles';

const Header = () => {
  const classes = useStyles();
  return (
    <header className={classes.header} data-testid={TEST_IDS.CONTAINER} data-pulse-section="header" data-pulse-group="header">
      <div className={classes.inner}>
        <Link href="/" data-testid={TEST_IDS.LOGO_LINK} data-pulse-name={PULSE_NAMES.GEN_AI_LOGO} className={classes.logoLink}>
          <Image src={GENAI_LOGO_URL} height={32} width={32} loading="eager" unoptimized alt="logo" className={classes.logoImg} />
          <div className={classes.textStack}>
            <span className={classes.title}>GenAi Studio</span>
            <span className={classes.subtitle}>By Picsart</span>
          </div>
        </Link>
        {/* Grouped with the auth cluster on the right, not centred: the field
            pushes itself there (see `root`'s auto margin) so it reads as part of
            the same control strip as Pricing. */}
        <SearchDropdown />
        <HeaderSearchLink />
        <HeaderAuthSlot />
      </div>
    </header>
  );
};

export default Header;
